import React, { useContext } from 'react';
import { Box } from '@mui/material';
import { UiContext } from 'uiContext';
import IconArrow from 'icons/iconArrow';
import { borderRadiusValues } from 'assets/theme';
import { IconsSizes } from 'hooks/useGetSpacing';

export default function ExpandButton({
  isOpen,
  onChangeIsOpen,
  isMobile = false,
  isTablet = false,
  sizeKey,
}: {
  isOpen: boolean;
  onChangeIsOpen: (isOpen: boolean) => void;
  isMobile?: boolean;
  isTablet?: boolean;
  sizeKey?: IconsSizes;
}) {
  const {
    spacings: { icons },
  } = useContext(UiContext);

  const style = isOpen ? { transform: 'rotate(180deg)' } : {};

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: isMobile ? 0 : 1,
        borderColor: 'customBackgrounds.contrast',
        borderRadius: borderRadiusValues.medium,
        cursor: 'pointer',
        width: isMobile || isTablet ? icons['32x32'].w : icons['40x40'].w,
        height: isMobile || isTablet ? icons['32x32'].h : icons['40x40'].w,
      }}
      onClick={() => onChangeIsOpen(!isOpen)}
    >
      <IconArrow sizeKey={sizeKey} style={style}></IconArrow>
    </Box>
  );
}
